import { syncedGet, syncedSet } from './serverStore';
import { getDefaultUnit } from './params';

const matrixKey = matrix => matrix === 'S' ? 'S' : 'L';
const categoryKey = category => String(category || 'Specific Analysis')
  .trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '') || 'specific_analysis';

export const categoryUnitStoreKey = (category, matrix) =>
  `sl_category_unit_defaults_${categoryKey(category)}_${matrixKey(matrix)}`;

const matrixFallback = (param, matrix) => {
  const adminMeta = syncedGet('sl_param_meta', {}) || {};
  const configured = matrixKey(matrix) === 'S'
    ? adminMeta[param]?.unitSolid
    : (adminMeta[param]?.unitLiquid ?? adminMeta[param]?.unit);
  if (configured !== undefined) return configured;
  let base = getDefaultUnit(param);
  if (/°f|\boF\b/i.test(String(param || ''))) base = '°F';
  if (matrixKey(matrix) === 'S') {
    if (base === 'mg/L') return 'mg/kg';
    if (base === 'ug/L') return 'ug/kg';
  }
  return base;
};

export function getCategoryUnit(param, category, matrix = 'L') {
  const saved = syncedGet(categoryUnitStoreKey(category, matrix), {}) || {};
  if (Object.prototype.hasOwnProperty.call(saved, param)) return saved[param];
  // TCLP results describe the liquid extract, even when the original sample
  // is a solid. Until a category-specific choice is saved, use liquid units.
  const effectiveMatrix = String(category || '').toLowerCase().includes('tclp') ? 'L' : matrix;
  return matrixFallback(param, effectiveMatrix);
}

export async function saveCategoryUnits(category, matrix, params, results) {
  const key = categoryUnitStoreKey(category, matrix);
  const defaults = { ...(syncedGet(key, {}) || {}) };
  (params || []).forEach(param => {
    if (results?.[param]?.unit !== undefined) defaults[param] = results[param].unit;
  });
  await syncedSet(key, defaults);
  return defaults;
}

export function resultsWithCategoryUnits(results, params, category, matrix) {
  const updated = { ...(results || {}) };
  (params || []).forEach(param => {
    updated[param] = {
      ...(updated[param] || {}),
      unit:getCategoryUnit(param, category, matrix),
    };
  });
  return updated;
}
